(function () {
  if (window.loadThemeSwiper) return;

  let pending;

  window.loadThemeSwiper = function loadThemeSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (pending) return pending;

    pending = new Promise((resolve, reject) => {
      const cssHref = window.theme?.swiperCssUrl;
      const jsSrc = window.theme?.swiperJsUrl;

      if (cssHref && !document.querySelector(`link[href="${cssHref}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssHref;
        document.head.appendChild(link);
      }

      if (!jsSrc) {
        reject(new Error('Missing Swiper asset URL'));
        return;
      }

      const existing = document.querySelector(`script[src="${jsSrc}"]`);
      if (existing) {
        existing.addEventListener('load', () => resolve(window.Swiper), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = jsSrc;
      script.defer = true;
      script.onload = () => resolve(window.Swiper);
      script.onerror = () => reject(new Error('Failed to load Swiper'));
      document.head.appendChild(script);
    });

    return pending;
  };
})();
